import { render, staticRenderFns } from "./Deceased.vue?vue&type=template&id=e1fcbcce&scoped=true&"
import script from "./Deceased.vue?vue&type=script&lang=js&"
export * from "./Deceased.vue?vue&type=script&lang=js&"
import style0 from "./Deceased.vue?vue&type=style&index=0&id=e1fcbcce&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1fcbcce",
  null
  
)

export default component.exports